var exports = {
  "_": "SubmitTooltip.module__buttonWrapper___SjhVMG",
};

module.exports = exports;
